import { CheckCircle, XCircle, AlertCircle } from 'lucide-react';

interface IntegrationStatusCardProps {
  name: string;
  description: string;
  isConnected: boolean;
  isEnabled: boolean;
  lastTested?: Date | null;
  icon: React.ReactNode;
  colorClass: string;
}

export function IntegrationStatusCard({
  name,
  description,
  isConnected,
  isEnabled,
  lastTested,
  icon,
  colorClass,
}: IntegrationStatusCardProps) {
  const getStatusBadge = () => {
    if (!isEnabled) {
      return (
        <span className="flex items-center gap-1 text-sm text-slate-500 font-medium">
          <XCircle className="w-4 h-4" />
          Disabled
        </span>
      );
    }

    if (isConnected) {
      return (
        <span className="flex items-center gap-1 text-sm text-green-600 font-medium">
          <CheckCircle className="w-4 h-4" />
          Connected
        </span>
      );
    }

    return (
      <span className="flex items-center gap-1 text-sm text-amber-600 font-medium">
        <AlertCircle className="w-4 h-4" />
        Not Configured
      </span>
    );
  };

  return (
    <div className="bg-white rounded-lg border border-slate-200 p-4 hover:shadow-md transition-shadow">
      <div className="flex items-start gap-3">
        <div className={`${colorClass} p-2 rounded-lg flex-shrink-0`}>
          {icon}
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between gap-2 mb-1">
            <h4 className="font-semibold text-slate-900">{name}</h4>
            {getStatusBadge()}
          </div>
          <p className="text-sm text-slate-600 mb-2">{description}</p>
          {lastTested && (
            <p className="text-xs text-slate-500">
              Last tested: {new Date(lastTested).toLocaleString()}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
